/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 * @flow
 */

import Container from 'components/Container';
import Header from 'components/Header';
import TitleAndMetaTags from 'components/TitleAndMetaTags';
import Layout from 'components/Layout';
import React from 'react';
import { sharedStyles } from 'theme';
import Visit404 from '../components/Apis/visit-404';
import MatrixBackground from '../components/matrix';

type Props = {
  location: Location,
};

const PageNotFound = ({ location }: Props) => (
  <Layout location={location}>
    <MatrixBackground />
    <Visit404 />
    <Container>
      <div css={sharedStyles.articleLayout.container}>
        <div css={sharedStyles.articleLayout.content}>
          <Header>Pagina non trovata</Header>
          <TitleAndMetaTags title="Milani - Pagina non trovata" />
          <div css={sharedStyles.markdown}>
            <p>Non siamo riusciti a trovare quello che stavi cercando.</p>
            <p>
              Contatta il proprietario del sito che ti ha collegato all'URL originale e comunicagli che il collegamento è interrotto.
            </p>
          </div>
        </div>
      </div>
    </Container>
  </Layout>
);

export default PageNotFound;
